import { WHY_CHAT_ME_ID } from "../../../../constant";
import Card from "./components/card";
import Content from "./components/content";
import { useState, useRef } from 'react';

const WhyChatMePage = () => {
    const [currentSlide, setCurrentSlide] = useState(1);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const sliderRef = useRef(null);

    const cardsData = [
        {
            src: "/media/images/icon/copy.png",
            title: "Swift and easy knowledge update",
            description: "Chat me is engineered for easy updates, ensuring your assistant remains up-to-date and effective at all times.",
            className: "w-12 h-12 md:w-10 md:h-10",
        },
        {
            src: "/media/images/icon/target.png",
            title: "Fast and accurate responses",
            description: "No customer query goes unanswered, enhancing your service reliability and customer satisfaction.",
            className: "w-12 h-12 md:w-10 md:h-10",
        },
        {
            src: "/media/images/icon/notification.png",
            title: "Dynamic messages",
            description: "Engage customers with videos, images and links, making every communication more interactive and informative.",
            className: "w-12 h-12 md:w-10 md:h-10",
            classNameTitle:"pb-9"
        },
        {
            src: "/media/images/icon/expand.png",
            title: "Versatile usage",
            description: "Engage customers with videos, images and links, making every communication more interactive and informative.",
            className: "w-12 h-12 md:w-10 md:h-10",
            classNameTitle:"pb-9"
        }
    ];

    const extendedCards = [
        cardsData[cardsData.length - 1],
        ...cardsData,
        cardsData[0]
    ];

    const handleTouchStart = (e) => {
        setTouchStart(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.touches[0].clientX);
    };

    const handleTransitionEnd = () => {
        if (currentSlide === 0) {
            setIsTransitioning(true);
            setCurrentSlide(cardsData.length);
            setTimeout(() => setIsTransitioning(false), 50);
        } else if (currentSlide === extendedCards.length - 1) {
            setIsTransitioning(true);
            setCurrentSlide(1);
            setTimeout(() => setIsTransitioning(false), 50);
        }
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > 50;
        const isRightSwipe = distance < -50;

        if (isLeftSwipe) {
            setCurrentSlide(prev => prev + 1);
        }
        if (isRightSwipe) {
            setCurrentSlide(prev => prev - 1);
        }

        setTouchStart(null);
        setTouchEnd(null);
    };

    return (
        <div id={WHY_CHAT_ME_ID} className="w-full py-12 bg-[#071807] box-border" style={{ fontFamily: 'Lexend Deca, sans-serif' }}>
            <Content />
            <div className="w-screen overflow-x-hidden md:overflow-hidden xl:w-full">
                {/* Mobile Slider */}
                <div className="block md:hidden relative">
                    <div 
                        ref={sliderRef}
                        className={`flex ${isTransitioning ? '' : 'transition-transform duration-300 ease-in-out'}`}
                        style={{ transform: `translateX(-${currentSlide * 90}%)` }}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onTransitionEnd={handleTransitionEnd}
                    >
                        {extendedCards.map((card, index) => {
                            const isActive = index === currentSlide;
                            return (
                                <div key={index} className="w-[90%] flex-shrink-0 p-4 pr-0">
                                    <Card
                                        src={card.src}
                                        title={card.title}
                                        description={card.description}
                                        className={card.className}
                                        classNameTitle={card.classNameTitle}
                                        isActive={isActive}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Desktop View */}
                <div className="hidden md:flex gap-4 px-4 py-4 sm:flex-wrap sm:justify-center md:px-10">
                    {cardsData.map((card, index) => (
                        <div key={index} className="w-[90%] flex-shrink-0 md:w-fit">
                            <Card
                                src={card.src}
                                title={card.title}
                                description={card.description}
                                className={card.className}
                                classNameTitle={card.classNameTitle}
                                isActive={false} // Không cần hiệu ứng hover tự động ở desktop
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WhyChatMePage;
